import { PersonIdDocument } from 'shared/components/(wallets)/kyc/PersonIdDocument';

import { SendInvitation } from '../SendInvitation/SendInvitation';

export const DocumentStep = () => {
    return (
        <>
            <SendInvitation step='document' />

            <PersonIdDocument />
        </>
    );
};

DocumentStep.displayName = 'DocumentStep';
